import { useApi } from '@/api';
import { Page, PageSkeleton } from '@/components';
import {
  Flex,
  KpiCard,
  KpiSkeleton,
  TableSkeleton,
  WalletAddress
} from '@blockanalitica/ui';
import { useParams } from 'react-router';
import LiquidatorTable from './LiquidatorTable';
import { DEFAULT_NETWORK } from '@/constants';

type LiquidationsStatsResponse = {
  liquidations: number;
  collateral_seized_usd: string;
  debt_repaid_usd: string;
  total_profits: string;
  liquidator_address: string;
};

export default function LiquidatorPage() {
  const { liquidatorAddress } = useParams() as {
    liquidatorAddress: string;
  };
  const network = DEFAULT_NETWORK;

  const [data, error] = useApi<LiquidationsStatsResponse>({
    url: `/liquidations/liquidators/${liquidatorAddress}/stats/`,
    queryParams: {}
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return (
      <PageSkeleton>
        <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
          <KpiSkeleton />
          <KpiSkeleton />
          <KpiSkeleton />
        </Flex>
        <TableSkeleton />
      </PageSkeleton>
    );
  }
  return (
    <Page
      title={
        <WalletAddress
          gap="s"
          options={{
            showCopyBtn: true,
            showEthScanLink: false,
            showDebankLink: true,
            showZapperLink: true,
            sizes: {
              icon: '8',
              walletAddressHeader: '4'
            },
            network: network
          }}
          address={data.liquidator_address}
        />
      }>
      <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
        <KpiCard
          title="# of Liquidations"
          data={data}
          field="number_of_liquidations"
        />
        <KpiCard
          title="Collateral Liquidated"
          data={data}
          field="total_collateral_seized_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
        <KpiCard
          title="Debt Repaid"
          data={data}
          field="total_debt_repaid_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
        <KpiCard
          title="Liquidator Profits"
          data={data}
          field="total_profits"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
      </Flex>
      <LiquidatorTable />
    </Page>
  );
}
